module.exports = __webpack_public_path__ + "img/home15.adc0b012.png";